import { HeldEmailRowActionItem } from "./HeldEmailRowActionItem";
import { HeldEmailRowActionsModel } from "./heldEmailRowActionsModel";

export function HeldEmailReleaseActions({
  model,
}: {
  model: HeldEmailRowActionsModel;
}) {
  return model.actionable ? (
    <>
      <HeldEmailRowActionItem
        action="release"
        heldEmailId={model.heldEmailId}
        onAction={model.onRelease}
      />
      <HeldEmailRowActionItem
        action="cancel"
        heldEmailId={model.heldEmailId}
        onAction={model.onCancel}
      />
    </>
  ) : null;
}
